import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StarRatingComponent } from '../../../shared/components/star-rating/star-rating.component';
import { NgIf, DecimalPipe } from '@angular/common';

@Component({
    selector: 'kb-product-review-rating-large',
    templateUrl: './product-review-rating-large.component.html',
    styleUrls: ['./product-review-rating-large.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        StarRatingComponent,
        DecimalPipe,
    ],
})
export class ProductReviewRatingLargeComponent {
    @Input() rating: number;
    @Input() reviewCount: number;
}
